module.exports = __webpack_public_path__ + "static/media/eight.9efbcdef.jpg";